import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, secondaryServices } from '../data';

export default function Footer() {
  return (
    <footer className="bg-slate-50 text-slate-900 pt-16 pb-8 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-1">
            <Link 
              to="/" 
              onClick={() => window.scrollTo(0, 0)}
              className="text-4xl font-black tracking-tighter mb-6 block uppercase"
            >
              KC<span className="text-slate-500">DETAILER</span>
            </Link>
            <p className="text-slate-600 leading-relaxed mb-6">
              Professionel bilpleje og certificeret keramisk coating. Vi passer på din bil, som var det vores egen.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase">Genveje</h4>
            <ul className="space-y-4 text-slate-600">
              <li><Link to="/fordele" className="hover:text-slate-900 transition-colors">Hvorfor Coating?</Link></li>
              <li><Link to="/priser" className="hover:text-slate-900 transition-colors">Pakker & Priser</Link></li>
              <li><Link to="/galleri" className="hover:text-slate-900 transition-colors">Galleri</Link></li>
              <li><Link to="/services" className="hover:text-slate-900 transition-colors">Vores Services</Link></li>
              <li><Link to="/kontakt" className="hover:text-slate-900 transition-colors">Kontakt Os</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase">Vores Services</h4>
            <ul className="space-y-4 text-slate-600">
              {secondaryServices.map(service => (
                <li key={service.slug}>
                  <Link to={`/service/${service.slug}`} className="hover:text-slate-900 transition-colors">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase">Åbningstider</h4>
            <ul className="space-y-4 text-slate-600">
              <li className="flex justify-between">
                <span>Mandag - Fredag</span>
                <span className="text-slate-900 font-medium">08:00 - 17:00</span>
              </li>
              <li className="flex justify-between">
                <span>Lørdag - Søndag</span>
                <span className="text-slate-900 font-medium">Efter aftale</span>
              </li>
              <li className="pt-4 border-t border-slate-100">
                <a href={`tel:${companyInfo.phone}`} className="text-slate-900 font-bold hover:text-slate-500 transition-colors">
                  Tlf: {companyInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${companyInfo.email}`} className="text-slate-900 font-bold hover:text-slate-500 transition-colors lowercase">
                  {companyInfo.email}
                </a>
              </li>
              <li className="pt-2">
                <p className="text-slate-900 font-bold">
                  {companyInfo.address}
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} KC Detailer – Alle rettigheder forbeholdes.</p>
          <p>CVR: 12345678</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-slate-900 transition-colors">Privatlivspolitik</a>
            <a href="#" className="hover:text-slate-900 transition-colors">Handelsbetingelser</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
